import GetStartedLayout from './get_started_layout.jsx'

const GetStartedPage = () => {
  return (
      <GetStartedLayout />
  );
};

export default GetStartedPage;